import { render, staticRenderFns } from "./MonthProductionResultTab.vue?vue&type=template&id=04a659c1&"
import script from "./MonthProductionResultTab.vue?vue&type=script&lang=js&"
export * from "./MonthProductionResultTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports